import styles from './LegalPage.module.css';

export function Terms() {
  return (
    <div className={styles.legalPage}>
      <h1 className={styles.title}>Terms of Service</h1>
      <p className={styles.lastUpdated}>Last updated: January 2026</p>

      <div className={styles.content}>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using TOKO Math Club ("Service"), you agree to be bound by these
          Terms of Service. If you do not agree to these terms, please do not use our Service.
        </p>

        <h2>2. Description of Service</h2>
        <p>
          TOKO Math Club provides educational math practice applications. The Service includes:
        </p>
        <ul>
          <li>Timed flashcard practice apps (TOKO Add, TOKO Multiply, and related apps)</li>
          <li>Multiplayer math races</li>
          <li>Progress tracking and performance analytics</li>
        </ul>
        <p>
          The Service is provided free of charge with no in-app purchases.
        </p>

        <h2>3. User Accounts</h2>
        <p>
          Some features require creating an account. You are responsible for maintaining
          the confidentiality of your account credentials and for all activities under your account.
        </p>
        <p>
          You may use the apps without an account for local practice. Creating an account
          enables multiplayer races and viewing progress on the web dashboard.
        </p>

        <h2>4. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Interfere with other users' enjoyment of the Service</li>
          <li>Use inappropriate usernames or conduct during multiplayer races</li>
        </ul>

        <h2>5. Children's Use</h2>
        <p>
          Our Service is designed for children with parental or teacher supervision.
          Parents, guardians, and teachers are responsible for monitoring children's use
          of the Service and ensuring appropriate conduct during multiplayer races.
        </p>

        <h2>6. Intellectual Property</h2>
        <p>
          All content, features, and functionality of the Service are owned by TOKO Math Club
          and are protected by intellectual property laws. You may not copy, modify, or
          distribute our content without permission.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          The Service is provided "as is" without warranties of any kind. We do not guarantee
          that the Service will be uninterrupted, secure, or error-free.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, TOKO Math Club shall not be liable for
          any indirect, incidental, or consequential damages arising from your use of the Service.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. We will notify users of significant
          changes by updating the "Last updated" date at the top of this page.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms shall be governed by the laws of the Republic of Austria, without regard
          to its conflict of law provisions. The exclusive place of jurisdiction is Salzburg, Austria.
        </p>

        <h2>11. Contact</h2>
        <p>
          For questions about these Terms, please contact us at:<br />
          <a href="mailto:office@AIquadrat.com">office@AIquadrat.com</a>
        </p>
      </div>
    </div>
  );
}
